<template>
  <div class="card mb-2">
    <div class="card-header bg-primary text-white d-flex">
      <a v-b-toggle="`collapse-associated-instruments-card`" class="collapse-icon c-pointer">
        <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
        <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
      </a>
      <span class="font-weight-bold">Associated Instruments</span>
    </div>
    <b-collapse
      v-model="showCollapse"
      :id="`collapse-associated-instruments-card`"
    >
      <div class="card-body">
      <LoadingSpinner v-if="loading" message ='Loading Associated Instruments' size = '1x'>
      </LoadingSpinner>
        <template v-if="!loading">
          <div v-if="!entities || entities.length === 0">
            No Instruments have been associated to this Property
          </div>
          <div v-for='entity in visibleEntities'
            :key='entity.id'
            class="card listing-card">
            <div class="card-body row">
              <div class="col-md-2">
                <div class="list-header">
                  Instrument ID
                </div>
                <div class="list-details">
                 {{entity.id || 'None'}}
                </div>
              </div>
              <div class="col-md-2">
                <div class="list-header">
                  Agreement Type
                </div>
                <div class="list-details">
                  {{ getAgreementTypeName(entity.agreementTypeId) }}
                </div>
              </div>
              <div class="col-md-2">
                <div class="list-header">
                  Instrument Type
                </div>
                <div class="list-details">
                  {{ getTypeString(entity.typeId) }}
                </div>
              </div>
              <div class="col-md-2">
                <div class="list-header">
                  Instrument Status
                </div>
                <div class="list-details">
                  {{ getStatusName(entity.statusId) || 'None'}}
                </div>
              </div>
              <div class = "col-md-4 d-flex justify-content-end align-self-center">
                <router-link
                :to="{ name: 'projectInstrument', params: {
                  project_id: $route.params.project_id,
                  id: entity.id }}"
                  class="btn btn-secondary btn-sm">
                  View
                </router-link>
              </div>
            </div>
          </div>
          <PaginationControls
           :orderedEntities="orderedEntities"
           :initialPageSize="initialPageSize"
           :pageSize="pageSize"
           :pageSizeOptions="pageSizeOptions"
           :currentPage="currentPage"
           :firstVisibleEntry="firstVisibleEntry"
           :lastVisibleEntry="lastVisibleEntry"
           :rows="rows"
           @update-current-page="updateCurrentPage"
           @update-page-size="updatePageSize">
          </PaginationControls>
        </template>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { EntityModules, LookupModules } from '@/store/moduleConfig';
import CollapseControl from '@/mixins/CollapseControl';
import LoadingSpinner from './LoadingSpinner.vue';
import Pagination from '@/mixins/Pagination';
import PaginationControls from './common/PaginationControls.vue';

export default {
  name: 'AssociatedInstrumentsCard',
  components: {
    LoadingSpinner,
    PaginationControls,
  },
  mixins: [CollapseControl, Pagination],
  data() {
    return {
      showCollapse: this.defaultOpened,
    };
  },
  created() {
    this.$store.dispatch(`${LookupModules.INSTRUMENT_TYPES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_TYPES.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_STATUSES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_STATUSES.url);
  },
  computed: {
    ...mapState(EntityModules.ASSOCIATED_INSTRUMENTS.namespace, {
      entities: state => state.entities,
      loading: state => state.loading,
    }),
    ...mapState(LookupModules.AGREEMENT_TYPES.namespace, {
      agreementTypesLoading: state => state.loading,
    }),
    ...mapState(LookupModules.INSTRUMENT_TYPES.namespace, {
      instrumentTypeLoading: state => state.loading,
    }),
    ...mapState(LookupModules.INSTRUMENT_STATUSES.namespace, {
      statusLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.INSTRUMENT_STATUSES.namespace, {
      getStatusName: 'getName',
      instrumentStatusOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_TYPES.namespace, {
      getTypeName: 'getName',
      getTypeProperty: 'getProperty',
      instrumentTypeOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.AGREEMENT_TYPES.namespace, {
      getAgreementTypeName: 'getName',
    }),
  },
  methods: {
    entitySort(a, b) {
      const statusCompare = a.statusId - b.statusId;
      if (statusCompare === 0) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      }
      return statusCompare;
    },
    getTypeString(id) {
      return id ? `${this.getTypeName(id)} (${this.getTypeProperty(id, 'code')})` : 'None';
    },
  },
};
</script>
